export const MODEL_FLASH = 'gemini-3.1-flash-image-preview'
export const MODEL_PRO = 'gemini-3-pro-image-preview'
